export const faqs = [
    // — Product basics —
    {
        q: 'What is AvenBox?',
        a: 'AvenBox is a private, portable AI control system built around local execution, trusted continuity, and explicit routing choices. It is designed to keep serious AI work under your control rather than defaulting to cloud systems you do not own.',
    },
    {
        q: 'Is AvenBox a finished product today?',
        a: 'No. AvenBox is a real working local AI, privacy, and orchestration prototype currently being shaped into a production-grade product. It is early and real — not a finished consumer platform.',
    },
    {
        q: 'What exists right now versus what is still in development?',
        a: 'Real now: the local AI backend, the privacy-first processing layer, the orchestration and agent core, and the desktop automation backend. Prototype now: voice assistant flows, browser and PC action flows, and the full interaction experience. Estimated / directional: current public pricing and the Q1 2027 launch target. Roadmap: finished hardware design, polished mobile app, full platform maturity, and consumer-grade reliability.',
    },

    // — Privacy and trust —
    {
        q: 'Does AvenBox depend on the cloud?',
        a: 'AvenBox is designed to be local-first. Core AI runs on the device itself. Outside services can be used as explicit, user-chosen paths — they are not the hidden default.',
    },
    {
        q: 'Is AvenBox just a local model box?',
        a: 'No. Local execution is part of the system, but the harder problem being solved is governance: where intelligence runs, what stays private, what can extend to trusted systems, and how those decisions stay under your control.',
    },
    {
        q: 'How should I think about the privacy and security model?',
        a: 'Privacy in AvenBox is an architectural decision, not a setting or a marketing claim. The system is designed around a trust boundary: what runs locally, what may extend to trusted environments, and what never leaves your control without your knowledge. Specific certification programs and formal security audits are part of the roadmap, not current claims.',
    },
    {
        q: 'Will AvenBox work completely offline?',
        a: 'AvenBox is local-first. Suitable tasks are intended to run on-device without a cloud connection. That said, the system is not designed for universal offline certainty in all scenarios — some workflows may involve explicit trusted extension paths when you choose them.',
    },

    // — Reservation and timeline —
    {
        q: 'What does the €1 reservation mean?',
        a: 'The €1 reservation is the current early-access mechanism. It records serious interest in one of the public reservation tracks. Paying the deposit does not lock final specifications, guarantee delivery timing, or mean the product is finished.',
    },
    {
        q: 'What does the €1 reservation not mean?',
        a: 'It is not a preorder for a finished product. It does not guarantee final pricing, final specifications, or a specific delivery date. The reservation exists at an early product stage and should be read as controlled early-access interest, not a purchase confirmation.',
    },
    {
        q: 'When is the launch planned?',
        a: 'The current public target is Q1 2027. That timing is directional — it reflects the current development direction and is not a fixed delivery commitment.',
    },

    // — Audience and compatibility —
    {
        q: 'Who is AvenBox built for first?',
        a: 'The first audience is privacy-sensitive professionals whose work, files, and internal thinking should not casually route through cloud systems — and early adopter founders and operators who want real AI leverage without giving up control or dependence discipline.',
    },
    {
        q: 'Will AvenBox work with more tools and workflows over time?',
        a: 'Yes, that is part of the direction. Broader ecosystem depth, deeper workflow continuity, and wider compatibility are roadmap goals — aligned with the Q1 2027 production target. They are not current product claims.',
    },
];

export const companyFaqs = [
    {
        q: 'Who founded Aven Studios?',
        a: 'Aven Studios was founded by Marko Vodopivec, who directs product vision, hardware engineering, and the orchestration framework. The company is founder-led and early-stage — building toward a Q1 2027 production target.',
    },
    {
        q: 'What makes AvenBox different from a local AI device?',
        a: 'Running a local model is the first step, not the full problem. The harder challenge is governing the complete system: where intelligence runs, what can extend outward, and what rules apply when it does. AvenBox is being built as the control layer that handles those decisions — not just a box that runs a local model.',
    },
    {
        q: 'How do I reach the team directly?',
        a: 'Contact is open for general questions, investor inquiries, and press. Email hello@avenstudios.com — handled directly by the founder. No intake filters.',
    },
];
